import React, { createContext, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { capitalizeWords } from "../../Usados/Inventario/helper/CapitalizeWords";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { Button, MenuItem, TextField } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ModalAgregarDocumentoSC } from "./ModalAgregarDocumentoSC";
import DeleteIcon from '@mui/icons-material/Delete';


export const RelacionDocumentosSCMain = () => {
    const history = useHistory();

    const [mostrarModal, setMostrarModal] = useState(false);
    const [predictivo, setPredictivo] = useState("");


    const [listado, setListado] = useState([]);
    const [listadoFiltrado, setListadoFiltrado] = useState([]);
    const [documentosMhusa, setDocumentosMhusa] = useState([]);
    const [documentosJDF, setDocumentosJDF] = useState([]);
    const [modificados, setModificados] = useState({});

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const onListado = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`RelacionDocumentosSC/Listado`)
            .then((result) => {
                setListado(result.listado);
                setListadoFiltrado(result.listado);

                setDocumentosMhusa(result.documentosMhusa);
                setDocumentosJDF(result.documentosJDF);

                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    }

    useEffect(() => {
        onListado()
    }, []);
    console.log(listadoFiltrado)
    useEffect(() => {
        if (predictivo.trim() === "") {
            setListadoFiltrado(listado);
            return;
        }

        const result = listado.filter((item) =>
            item.documentoJDF.toUpperCase().includes(predictivo.toUpperCase()) ||
            item.documentoMhusa.toUpperCase().includes(predictivo.toUpperCase())
        );

        setListadoFiltrado(result);
    }, [predictivo, listado]);

    const onGuardar = (datos) => {
        const detalle = Object.values(datos);

        if (detalle.length === 0) {
            Swal.fire("Atención", "No hay cambios para guardar", "warning");
            return;
        }

        // console.log(payload)
        request
            .post("RelacionDocumentosSC/Guardar", { detalle: JSON.stringify(detalle), })
            .then(() => {
                Swal.fire("RELACION DE DOCUMENTOS", "Guardado correctamente", "success");
                onListado()
                setModificados({});
                setPredictivo("")
            })
            .catch((error) => {
                Swal.fire("Error", JSON.stringify(error), "error");
            });
    };

    const onDelete = (idmhusa, idJDF) => {

        // console.log(payload)
        request
            .get(`RelacionDocumentosSC/delete?idmhusa=${idmhusa}&idJDF=${idJDF}`)
            .then(() => {
                Swal.fire("RELACION DE DOCUMENTOS", "Eliminado correctamente", "success");
                onListado()
            })
            .catch((error) => {
                Swal.fire("Error", JSON.stringify(error), "error");
            });
    };

    const onAgregar = (id) => {
        setMostrarModal(true)
    }

    const SelectDocumento = ({
        value,
        options,
        onChange,
    }) => {
        return (
            <TextField
                fullWidth
                size="small"
                variant="outlined"
                select
                value={value}
                onChange={onChange}
            >
                {options.map((opt) => (
                    <MenuItem key={opt.iddocumento} value={opt.iddocumento}>
                        {opt.documento}
                    </MenuItem>
                ))}
            </TextField>
        );
    }

    const actualizarRelacion = ({
        rowKey,
        iddocumentoJDF,
        iddocumentoMhusa,
    }) => {
        setModificados((prev) => {
            const actual = prev[rowKey] || {};

            return {
                ...prev,
                [rowKey]: {
                    iddocumentoJDF:
                        iddocumentoJDF !== undefined
                            ? iddocumentoJDF
                            : actual.iddocumentoJDF,

                    iddocumentoMhusa:
                        iddocumentoMhusa !== undefined
                            ? iddocumentoMhusa
                            : actual.iddocumentoMhusa,
                },
            };
        });
    };

    console.log(modificados)
    return (
        <PlantillaScreen
            titulo={"DOCUMENTOS RELACIONADOS EN SOLICITUDES DE CREDITO"}
            className={"Relacion-Documentos-Main-Container"}
            className_main={2}
        >
            <ModalAgregarDocumentoSC
                onClose={() => setMostrarModal(false)}
                open={mostrarModal}
                documentosMhusa={documentosMhusa}
                documentosJDF={documentosJDF}
                onGuardar={onGuardar}
            />

            <div className="Relacion-Documentos-Main-Header">
                <div
                    className="Relacion-Documentos-Main-Header-regresar"
                    onClick={() => history.push("/Credito/Main")}
                >
                    <ArrowBackIcon /> Regresar
                </div>

                <div className='Relacion-Documentos-Main-Header-agregar'>
                    <Button
                        variant="contained"
                        className='lineas-scorecard-agregar-nueva-linea'
                        onClick={() => onAgregar()}
                    >
                        <AddCircleOutlineIcon />
                        Agregar
                    </Button>
                </div>
            </div>
            <LoaderScreen loader={loader} />
            <div className="listado-clientes-noregistrados-screen">
                <div className="listado-clientes-noregistrados-header-control">
                    <TextField
                        color="success"
                        fullWidth
                        size="small"
                        value={predictivo}
                        onChange={({ target }) => setPredictivo(target.value)}
                        placeholder="Buscar Documento..."
                    />
                </div>
                <div className="listado-documentos-relacionados-container scroll-4">
                    {listadoFiltrado !== undefined &&
                        listadoFiltrado !== null &&
                        listadoFiltrado.length > 0 ? (
                        <div className="contenedor-tablas">
                            {/* TABLA IZQUIERDA */}
                            <table className="tabla tabla-izq" cellSpacing={0} cellPadding={0}>
                                <thead>
                                    <tr>
                                        <th>Documento JDF</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listadoFiltrado.map((row, index) => (
                                        <tr key={row.id}>
                                            <td>
                                                <SelectDocumento
                                                    value={row.iddocumentoJDF}
                                                    options={documentosJDF}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Actualiza listado visual
                                                        setListado((prev) =>
                                                            prev.map((r, i) =>
                                                                i === index
                                                                    ? { ...r, iddocumentoJDF: value }
                                                                    : r
                                                            )
                                                        );

                                                        // Actualiza modificados
                                                        actualizarRelacion({
                                                            rowKey: index,
                                                            iddocumentoJDF: value,
                                                            iddocumentoMhusa: row.iddocumentoMhusa,
                                                        });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* COLUMNA FLECHAS */}
                            <div className="columna-flechas">
                                <div className="flecha-header"></div>
                                {listadoFiltrado.map((_, index) => (
                                    <div key={index} className="flecha-fila">
                                        →
                                    </div>
                                ))}
                            </div>

                            {/* TABLA DERECHA */}
                            <table className="tabla tabla-der" cellSpacing={0} cellPadding={0}>
                                <thead>
                                    <tr>
                                        <th>Documento MHUSA</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listadoFiltrado.map((row, index) => (
                                        <tr key={row.id}>
                                            <td>
                                                <SelectDocumento
                                                    label="Documento MHUSA"
                                                    value={row.iddocumentoMhusa}
                                                    options={documentosMhusa}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Actualiza listado visual
                                                        setListado((prev) =>
                                                            prev.map((r, i) =>
                                                                i === index
                                                                    ? { ...r, iddocumentoMhusa: value }
                                                                    : r
                                                            )
                                                        );

                                                        // Actualiza modificados
                                                        actualizarRelacion({
                                                            rowKey: index,
                                                            iddocumentoMhusa: value,
                                                            iddocumentoJDF: row.iddocumentoJDF,
                                                        });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* COLUMNA FLECHAS */}
                            <div className="columna-flechas">
                                <div className="flecha-header"></div>
                                {listadoFiltrado.map((element, index) => (
                                    <div key={index} onClick={() => onDelete(element.iddocumentoMhusa, element.iddocumentoJDF)} className="delete-fila">
                                        <DeleteIcon />
                                    </div>
                                ))}
                            </div>
                        </div>


                    ) : (
                        <div className="contenedor-tablas">
                            {/* TABLA IZQUIERDA */}
                            <table className="tabla tabla-izq" cellSpacing={0} cellPadding={0}>
                                <thead>
                                    <tr>
                                        <th>Documento JDF</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* COLUMNA FLECHAS */}
                            <div className="columna-flechas-b">
                                <div className="flecha-header-b"></div>
                                <div className="flecha-fila">
                                    →
                                </div>

                            </div>

                            {/* TABLA DERECHA */}
                            <table className="tabla tabla-der" cellSpacing={0} cellPadding={0}>
                                <thead>
                                    <tr>
                                        <th>Documento MHUSA</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div>
                        <table></table>
                    </div>
                </div>
                {/* <button
                    onClick={() => onGuardar(modificados)}
                    disabled={Object.keys(modificados).length === 0}
                >
                    Guardar cambios
                </button> */}
                {Object.keys(modificados).length > 0 && (
                    <div className="boton-guardar-tabla">
                        <Button variant="contained"
                            onClick={() => onGuardar(modificados)}
                        >
                            Guardar cambios
                        </Button>
                    </div>
                )}
            </div>
        </PlantillaScreen>
    );
};
